import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";
import {
  loginSuccess,
  logout,
  setLoading,
  setError,
  clearError,
  updateUser,
} from "./slices/authSlice";

// Typed hooks for Redux (reusable pattern)
export const useAppDispatch = () => useDispatch();
export const useAppSelector = useSelector;

// Custom hook for auth state and actions
export const useAuthRedux = () => {
  const dispatch = useAppDispatch();
  const auth = useAppSelector((state) => state.auth);

  const handleLoginSuccess = useCallback(
    (payload) => {
      dispatch(loginSuccess(payload));
    },
    [dispatch]
  );

  const handleLogout = useCallback(() => {
    dispatch(logout());
  }, [dispatch]);

  const handleSetLoading = useCallback(
    (loading) => {
      dispatch(setLoading(loading));
    },
    [dispatch]
  );

  const handleSetError = useCallback(
    (error) => {
      dispatch(setError(error));
    },
    [dispatch]
  );

  const handleClearError = useCallback(() => {
    dispatch(clearError());
  }, [dispatch]);

  const handleUpdateUser = useCallback(
    (userData) => {
      dispatch(updateUser(userData));
    },
    [dispatch]
  );

  return {
    ...auth,
    loginSuccess: handleLoginSuccess,
    logout: handleLogout,
    setLoading: handleSetLoading,
    setError: handleSetError,
    clearError: handleClearError,
    updateUser: handleUpdateUser,
  };
};

